import { useParams } from 'react-router-dom';
import IncentiveManagement from './incentive/IncentiveManagement';

export default function ExternalCompanyIncentive() {
  const { code } = useParams();
  return <IncentiveManagement companyCode={(code || '').toUpperCase()} />;
}
